import { List } from "../Utils/List";
import { Dictionary } from "../Utils/Dictionary";
import { HashSet } from "../Utils/HashSet";
import { TopoEdge } from "../Topology/TopoEdge";
import { TopoNode } from "../Topology/TopoNode";
import { TopoConnection } from "../Topology/TopoConnection";
import { TopoLinkMember } from "../Topology/TopoLinkMember";

export class TopoEdgeSet {
	private _topoEdges: HashSet<TopoEdge>;
	private _nodeEdges: Dictionary<TopoNode, List<TopoEdge>>;

	constructor() {
		this._topoEdges = new HashSet<TopoEdge>();
		this._nodeEdges = new Dictionary<TopoNode, List<TopoEdge>>();
	}

	public ToList(): List<TopoEdge> {
		return this._topoEdges.ToList();
	}
		
	public AddEdge_Nodes(node1: TopoNode, node2: TopoNode): TopoEdge {
		var edge = new TopoEdge(node1, node2);
		this.AddEdge(edge);
		return edge;
	}

	public AddEdges(edges: List<TopoEdge>): void {
		edges.ForEach((e) => {
			this.AddEdge(e);
		});
	}

	public AddEdge(edge: TopoEdge) {
		this._topoEdges.Add(edge);
		this.AddNodeEdge(edge.LocalNode, edge);
		this.AddNodeEdge(edge.RemoteNode, edge);
	}

	public RemoveNodeEdges(node: TopoNode): void {
		if (this._nodeEdges.ContainsKey(node)) {
			var nodeEdges: List<TopoEdge> = this._nodeEdges.Item(node);
			this._nodeEdges.Remove(node);

			nodeEdges.ForEach((edge) => {
				this._topoEdges.Remove(edge);

				this._nodeEdges.ForEach((pair) => {
					pair.Value.Remove(edge);
				});
			});
		}
	}

	private AddNodeEdge(node: TopoNode, edge: TopoEdge): void {
		if (!this._nodeEdges.ContainsKey(node))
			this._nodeEdges.Add(node, new List<TopoEdge>());

		this._nodeEdges.Item(node).Add(edge);
	}

	public AddTopoLinkMember(connection1: TopoConnection, connection2: TopoConnection): TopoLinkMember {
		var node1: TopoNode = connection1.Node;
		var node2: TopoNode = connection2.Node;

		var edge: TopoEdge = this.FindEdge(node1, node2);
		if (edge == null)
			edge = this.AddEdge_Nodes(node1, node2);

		var topoLink = new TopoLinkMember(connection1, connection2);
		edge.AddLinkMember(topoLink);

		return topoLink;
	}

	public FindEdge(node1: TopoNode, node2: TopoNode): TopoEdge {
		var edges: List<TopoEdge> = this._nodeEdges.Item(node1);
		if (edges != null) {
			var foundEdge: TopoEdge = null;
			edges.Some((edge) => {
				if (edge.ContainsNode(node2)) {
					foundEdge = edge;
					return true;
				}
			});
			return foundEdge;
		}
		else
			return null;
	}

	public NodeEdges(node: TopoNode): List<TopoEdge> {
		if (this._nodeEdges.ContainsKey(node))
			return this._nodeEdges.Item(node);
		else
			return new List<TopoEdge>();
	}

	public NodeHasEdges(node: TopoNode): boolean {
		return this._nodeEdges.ContainsKey(node);
	}

	public Clear(): void {
		this._topoEdges.Clear();
		this._nodeEdges.Clear();
	}
}
